// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3Pson","label":"CategoryService_label__1G1rN","location":"CategoryService_location__15_uy"};